import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 100px; 
    }`
  }
`

const FilterRangeIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="150" height="15" viewBox="0 0 150 15" isFromWidgetChoice={isFromWidgetChoice}>
      <g id="filter_range" transform="translate(-631.5 -353)">
        <circle id="Ellipse_1838" data-name="Ellipse 1838" cx="6" cy="6" r="6" transform="translate(657.5 354.5)" fill="none" stroke="#707070" strokeWidth="3"/>
        <circle id="Ellipse_1839" data-name="Ellipse 1839" cx="6" cy="6" r="6" transform="translate(721.5 354.5)" fill="none" stroke="#707070" strokeWidth="3"/>
        <line id="Ligne_515" data-name="Ligne 515" x1="53" transform="translate(668.5 360.5)" fill="none" stroke="#707070" strokeWidth="3"/>
        <line id="Ligne_516" data-name="Ligne 516" x1="21" transform="translate(631.5 360.5)" fill="none" stroke="#707070" strokeWidth="1"/>
        <line id="Ligne_517" data-name="Ligne 517" x1="43" transform="translate(738.5 360.5)" fill="none" stroke="#707070" strokeWidth="1"/>
      </g>
    </SVG>
  </IconContainer>
)

export default FilterRangeIcon